function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 512,
  r: 350,
  fill: "none",
  stroke: "white",
  strokeWidth: 20
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 512,
  r: 250,
  fill: "none",
  stroke: "white",
  strokeWidth: 16
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 512,
  r: 200,
  fill: "none",
  stroke: "white",
  strokeWidth: 12
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 512,
  r: 150,
  fill: "none",
  stroke: "white",
  strokeWidth: 10
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 512,
  r: 100,
  fill: "none",
  stroke: "white",
  strokeWidth: 8
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 512,
  r: 80,
  fill: "none",
  stroke: "white",
  strokeWidth: 5
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 450,
  cy: 380,
  r: 50,
  fill: "none",
  stroke: "white",
  strokeWidth: 5,
  opacity: 0.6
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 574,
  cy: 380,
  r: 50,
  fill: "none",
  stroke: "white",
  strokeWidth: 5,
  opacity: 0.6
});

var SvgFutsal = function SvgFutsal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFutsal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/futsal.d2be7e33.svg";
export { ForwardRef as ReactComponent };